import { UserRoleInterface } from '../interfaces/userRole';

export class UserRole implements UserRoleInterface {
    IDUserRole?: number;
    UserRole: string;

    constructor() {
        this.UserRole = '';
    }
}
